export enum UrlImageDefaultEnum{
    url = "assets/images/coming-soon.svg"
}